/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$ref: FragmentReference;
export type ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader = {|
  +cta: ?string,
  +imagePath: ?string,
  +linkPath: ?string,
  +subtitle: ?string,
  +title: ?string,
  +$refType: ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader",
  "type": "ContemporaryLandingSplashHeader",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imagePath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subtitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8ec96da1743ec877f026ff44db92138d';
module.exports = node;
